import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './pages/login/login.component';
import { PortalComponent } from './pages/portal/portal.component';
import { MisIniciativasComponent } from './pages/mis-iniciativas/mis-iniciativas.component';
import { AdministracionComponent } from './pages/administracion/administracion.component';
import { AuthGuard } from './services/auth.guard';
import { LiderProyectoComponent } from './pages/lider-proyecto/lider-proyecto.component';
import { ModalUsuarioComponent} from './components/modal-usuario/modal-usuario.component';
import { ControlUsuariosComponent } from './components/administracion/control-usuarios/control-usuarios.component';
import { ModalUsuarioEdicionComponent } from './components/modal-usuario-edicion/modal-usuario-edicion.component';
import { CosteoProcesoComponent } from './components/costeo-proceso/costeo-proceso.component';
import {NuevoSistemaComponent} from './components/nuevo-sistema/nuevo-sistema.component';
import {CambiosFuncionalidadesComponent} from './components/cambios-funcionalidades/cambios-funcionalidades.component';
import {ModalConsultaIniciativaComponent} from './components/modal-consulta-iniciativa/modal-consulta-iniciativa.component';
import { SeleccionRolComponent } from './pages/seleccion-rol/seleccion-rol.component';
import { TablaIniciativasComponent } from 'src/app/components/administracion/tabla-iniciativas/tabla-iniciativas.component'
import {ModalPriorizacionComponent} from 'src/app/components/modal-priorizacion/modal-priorizacion.component'
import {EquipoTrabajoComponent} from 'src/app/components/equipo-trabajo/equipo-trabajo.component'
import {ReportesComponent} from './components/administracion/reportes/reportes.component';



const routes: Routes = [
  {path: 'login', component: LoginComponent},
  {path: 'portal', component: PortalComponent, canActivate: [AuthGuard]},
  {path: 'mis-iniciativas', component: MisIniciativasComponent, canActivate: [AuthGuard]},
  {path: 'iniciativas', component: TablaIniciativasComponent, canActivate: [AuthGuard]},
  {path: 'iniciativas-priorizacion', component: ModalPriorizacionComponent},
  {path: 'seleccion-rol', component: SeleccionRolComponent},

  {path: 'administracion', component: AdministracionComponent, canActivate: [AuthGuard]},
  {path: 'lider-proyecto', component: LiderProyectoComponent, canActivate: [AuthGuard]},
  {path: 'add-usuario', component:  ModalUsuarioComponent, canActivate: [AuthGuard]},
  {path: 'update-usuario/:email_usuario', component:  ModalUsuarioEdicionComponent, canActivate: [AuthGuard]},
  {path: 'control-usuarios', component:  ControlUsuariosComponent},
  {path: 'costeo', component:  CosteoProcesoComponent, canActivate: [AuthGuard]},
  {path: 'nuevo-sistema', component: NuevoSistemaComponent, canActivate: [AuthGuard]},
  {path: 'consulta-iniciativa', component: ModalConsultaIniciativaComponent, canActivate: [AuthGuard]},
  {path: 'equipo-trabajo', component: EquipoTrabajoComponent, canActivate: [AuthGuard]},
  {path: 'cambios-funcionalidades', component:CambiosFuncionalidadesComponent, canActivate: [AuthGuard]},
  {path: 'reportes', component: ReportesComponent, canActivate: [AuthGuard]},
  {path: '', pathMatch: 'full', redirectTo: 'login'},
  {path: '**', pathMatch: 'full', redirectTo: 'login'},
  

];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true, relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
